import { CSSObject } from '@chakra-ui/react';

export const FlexBetCard: CSSObject = {
  rowGap: '2',
  w: '100%',
};
